import React, { FC, useCallback, useMemo } from 'react';
import LinkIcon from '@mui/icons-material//Link';
import { Link } from '@mui/material';
import queryString from 'query-string';
import { useNavigate, useParams } from 'react-router-dom';
import { documentsUrl } from 'common/config/urls';
import { DOCUMENTS_SLUG, QUESTIONS_SLUG } from 'common/constants/documents';
import { setQueryString } from 'utilities';
import useStyles from './styles';
import { LinkToInformationRequestProps } from './types';

const LinkToInformationRequest: FC<LinkToInformationRequestProps> = ({
  companySlug,
  isDocuments,
  measurementDateFormatted,
}) => {
  const { firmSlugParam } = useParams<{ firmSlugParam: string }>();
  const navigate = useNavigate();
  const classes = useStyles();

  const baseUrl = useMemo(() => documentsUrl(firmSlugParam, companySlug), [firmSlugParam, companySlug]);
  const tab = isDocuments ? DOCUMENTS_SLUG : QUESTIONS_SLUG;
  const url = useMemo(
    () => `${baseUrl}?date=${measurementDateFormatted}&tab=${tab}`,
    [baseUrl, measurementDateFormatted, tab]
  );

  const redirectToUrl = useCallback(() => {
    const parsedUrl = new URL(url, window.location.origin);
    const { pathname, search } = parsedUrl;

    const parsedQuery = queryString.parse(search);

    setQueryString({
      navigate,
      paramName: '',
      paramValue: '',
      pathname,
      searchParams: queryString.stringify(parsedQuery),
      shouldPushPath: true,
    });
  }, [navigate, url]);

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link component="button" variant="body2" onClick={redirectToUrl} className={classes.link}>
      Go to Information Request
      <LinkIcon className={classes.icon} />
    </Link>
  );
};

export default LinkToInformationRequest;
